import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function GuaranteeSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-white relative border-y border-brand-gold/10" data-id="element-203">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-205">
          <div className="w-20 h-20 bg-brand-gold/10 rounded-full flex items-center justify-center mx-auto mb-6 md:mb-8" data-id="element-206">
            <ShieldCheck className="w-10 h-10 text-brand-gold" data-id="element-207" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-208">
            {t('guarantee.title')}
          </h2>

          <div className="space-y-6 text-lg text-brand-charcoal max-w-2xl mx-auto" data-id="element-209">
            <p data-id="element-210">{t('guarantee.p1')}</p>
            <p className="font-medium text-xl text-brand-brown" data-id="element-211">
              {t('guarantee.p2')}
            </p>
            <p data-id="element-212">{t('guarantee.p3')}</p>
            <div className="bg-brand-cream p-6 rounded-sm border border-brand-gold/20 mt-8" data-id="element-213">
              <p className="italic" data-id="element-214">{t('guarantee.p4')}</p>
              <p className="font-bold text-brand-gold mt-2 uppercase tracking-widest text-sm" data-id="element-215">
                {t('guarantee.p5')}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}